const selectorInert = "#menu-header, #site-main, #site-footer, #skip-to-content";

export { selectorInert };


